import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import CurriculumLinkWrapper from './styled';

const CurriculumTopicLink = ({ curriculumLevelDescriptions, placeholder, handleCurriculumChange, defaultValue }) => (<CurriculumLinkWrapper>
    <Select
        defaultValue={defaultValue}
        isClearable
        isSearchable
        onChange={handleCurriculumChange}
        options={curriculumLevelDescriptions || []}
        placeholder={placeholder}
    />
</CurriculumLinkWrapper>);
CurriculumTopicLink.propTypes = {
    curriculumLevelDescriptions: PropTypes.array,
    placeholder: PropTypes.string,
    handleCurriculumChange: PropTypes.func,
    defaultValue: PropTypes.object
};

export default CurriculumTopicLink;



// WEBPACK FOOTER //
// ./app/components/curriculum-topic-link/index.js